import { render, staticRenderFns } from "./SalesByClient.vue?vue&type=template&id=33a9847a&"
import script from "./SalesByClient.vue?vue&type=script&lang=js&"
export * from "./SalesByClient.vue?vue&type=script&lang=js&"
import style0 from "./SalesByClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports